/* tslint:disable */
/* eslint-disable */
/**
 * SONeu.WebApi | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface DutyScheduleDistributionMetricsResponse
 */
export interface DutyScheduleDistributionMetricsResponse {
    /**
     * 
     * @type {number}
     * @memberof DutyScheduleDistributionMetricsResponse
     */
    hoursPerFte: number;
    /**
     * 
     * @type {number}
     * @memberof DutyScheduleDistributionMetricsResponse
     */
    hoursPerFtePerMonth: number;
    /**
     * 
     * @type {number}
     * @memberof DutyScheduleDistributionMetricsResponse
     */
    bgsPerFte: number;
}

/**
 * Check if a given object implements the DutyScheduleDistributionMetricsResponse interface.
 */
export function instanceOfDutyScheduleDistributionMetricsResponse(value: object): value is DutyScheduleDistributionMetricsResponse {
    if (!('hoursPerFte' in value) || value['hoursPerFte'] === undefined) return false;
    if (!('hoursPerFtePerMonth' in value) || value['hoursPerFtePerMonth'] === undefined) return false;
    if (!('bgsPerFte' in value) || value['bgsPerFte'] === undefined) return false;
    return true;
}

export function DutyScheduleDistributionMetricsResponseFromJSON(json: any): DutyScheduleDistributionMetricsResponse {
    return DutyScheduleDistributionMetricsResponseFromJSONTyped(json, false);
}

export function DutyScheduleDistributionMetricsResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): DutyScheduleDistributionMetricsResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'hoursPerFte': json['hoursPerFte'],
        'hoursPerFtePerMonth': json['hoursPerFtePerMonth'],
        'bgsPerFte': json['bgsPerFte'],
    };
}

export function DutyScheduleDistributionMetricsResponseToJSON(json: any): DutyScheduleDistributionMetricsResponse {
    return DutyScheduleDistributionMetricsResponseToJSONTyped(json, false);
}

export function DutyScheduleDistributionMetricsResponseToJSONTyped(value?: DutyScheduleDistributionMetricsResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'hoursPerFte': value['hoursPerFte'],
        'hoursPerFtePerMonth': value['hoursPerFtePerMonth'],
        'bgsPerFte': value['bgsPerFte'],
    };
}

